export enum HelpCategory {
  GRAPHICS = "graphics",
  NETWORK_UDP = "network_udp",
  NETWORK_TCP = "network_tcp",
  ANT_PLUS = "ant_plus",
  BLUETOOTH = "bluetooth",
  SEARCH = "search",
  GENERAL = "general"
}

export interface HelpTopic {
  id: string;
  title: string;
  content: string;
  category: HelpCategory;
  relatedTopics?: string[];
  keywords?: string[];
}

export interface HelpSection {
  category: HelpCategory;
  title: string;
  description?: string;
  topics: string[];
}

export type HelpContent = Record<string, HelpTopic>;
export type HelpSections = Record<HelpCategory, HelpSection>;
